import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TeacherFeedbackDto } from '../teacher-feedback-service/teacher-feedback-dto';
import { MODAL_DATA } from '../../shared/tokens/modal-data.token';

@Component({
  selector: 'lp2-teacher-feedback-modal',
  templateUrl: './teacher-feedback-modal.component.html',
  styleUrls: ['./teacher-feedback-modal.component.scss'],
})
export class TeacherFeedbackModalComponent {
  public feedback: TeacherFeedbackDto;
  // these input output parameters work as a two-way data binding for the feedback parameter on the parent component.
  @Output() feedbackChange: EventEmitter<TeacherFeedbackDto> = new EventEmitter();

  constructor(
    private ngbActiveModal: NgbActiveModal,
    @Inject(MODAL_DATA) public readonly data: any
  ) {}

  ngOnInit() {
    this.feedback = this.data.feedback;
  }

  close() {
    this.ngbActiveModal.close();
  }

  emitFeedbackChange() {
    this.feedbackChange.emit(this.feedback);
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-modal/teacher-feedback-modal.component.ts